interface Props {
  eyebrow: string;
  title: string[];
  text?: string;
  light?: boolean;
}

export default function SectionHead({ eyebrow, title, text, light }: Props) {
  return (
    <div className="section-head">
      <p className={light ? 'eyebrow light' : 'eyebrow'}>{eyebrow}</p>
      <h2>
        {title.map((line, index) => (
          <span key={line}>
            {line}
            {index < title.length - 1 && <br />}
          </span>
        ))}
      </h2>
      {text && <p>{text}</p>}
    </div>
  );
}
